const dashboardTranslations = {
  waterInTake: "Water In Take",
  renewProgramButton: "Renew Your Form",
};

export default dashboardTranslations;
